{
  "platform": {
    "integrations": {
      "nav": "التكاملات",
      "zoho": {
        "title": "Zoho CRM",
        "subtitle": "الربط الذي ينسخ طلبات العرض التوضيحي إلى مؤسسة Zoho CRM الخاصة بالمالك. تبقى الرموز والبيانات السرية على الخادم ولا تُعرض هنا أبداً.",
        "connection": "الربط",
        "status": "الحالة",
        "connected": "مرتبط",
        "notConnected": "غير مرتبط",
        "orgId": "رقم المؤسسة",
        "orgVerified": "تم التحقق من المؤسسة",
        "environment": "البيئة",
        "dataCentre": "مركز البيانات",
        "apiDomain": "عنوان واجهة البرمجة (API)",
        "scopes": "نطاقات الصلاحية",
        "noScopes": "لا يوجد",
        "connectedAt": "تاريخ الربط",
        "connectedBy": "رُبط بواسطة",
        "lastVerified": "آخر تحقق",
        "connect": "ربط Zoho CRM",
        "connectHint": "ستسجّل الدخول في Zoho لتفويض الربط، ثم تعود إلى هذه الصفحة.",
        "cannotStart": "لا يمكن ربط Zoho CRM بعد",
        "reconnect": "إعادة الربط",
        "reconnectHint": "تُبقي إعادة الربط على الربط الحالي حتى يُتحقق من الربط الجديد.",
        "unsafeAddress": "أعاد الخادم عنوان تسجيل دخول ليس صفحة تسجيل الدخول في Zoho لمركز البيانات السعودي، لذلك لم يُفتح.",
        "disconnect": "إلغاء الربط",
        "disconnectTitle": "إلغاء ربط Zoho CRM؟",
        "disconnectBody": "يتوقف فيدلن عن إرسال العملاء المحتملين إلى Zoho حتى يُعاد الربط. لا يُحذف أي عميل محتمل، لا في فيدلن ولا في Zoho.",
        "disconnected": "أُلغي ربط Zoho CRM.",
        "resultConnected": "تم ربط Zoho CRM.",
        "resultRefused": "لم يكتمل ربط Zoho CRM",
        "sync": "مزامنة العملاء المحتملين",
        "syncEnabled": "المزامنة",
        "syncOn": "مفعّلة",
        "syncOff": "متوقفة",
        "syncReadOnly": "للاطلاع فقط: لا تُفعَّل المزامنة ولا تُوقَف من هذه الواجهة.",
        "ownerPolicy": "سياسة مالك العملاء المحتملين",
        "ownerVerified": "تم التحقق من مالك العملاء المحتملين",
        "fieldMapValid": "ربط الحقول صالح",
        "problems": "المشكلات",
        "noProblems": "لا توجد مشكلات مُبلّغ عنها.",
        "problem": {
          "accounts_url_invalid": "عنوان حسابات Zoho على الخادم مفقود أو ليس عنوان حسابات تابعاً لـ Zoho (فريق DevOps)",
          "api_domain_invalid": "عنوان واجهة برمجة Zoho على الخادم مفقود أو ليس عنواناً تابعاً لـ Zoho (فريق DevOps)",
          "data_centre_mismatch": "عنوان الحسابات وعنوان واجهة البرمجة على الخادم يتبعان مركزَي بيانات مختلفين في Zoho (فريق DevOps)",
          "environment_invalid": "بيئة Zoho على الخادم ليست بيئة الإنتاج ولا البيئة التجريبية (فريق DevOps)",
          "api_domain_environment_mismatch": "عنوان واجهة برمجة Zoho على الخادم لا يطابق البيئة المُعدّة (فريق DevOps)",
          "client_id_missing": "مُعرّف عميل Zoho غير مضبوط على الخادم (فريق DevOps)",
          "client_secret_missing": "الرمز السري لعميل Zoho غير مضبوط على الخادم (فريق DevOps)",
          "org_id_invalid": "رقم مؤسسة Zoho على الخادم مفقود أو غير صالح (فريق DevOps)",
          "field_map_invalid": "ربط الحقول مع Zoho على الخادم مفقود أو غير صالح (فريق DevOps)",
          "lead_source_inconsistent": "قيمة مصدر العميل المحتمل وربط حقلها على الخادم يُضبطان معاً أو لا يُضبط أيّ منهما (فريق DevOps)",
          "redirect_uri_invalid": "عنوان إعادة التوجيه لـ Zoho على الخادم مفقود أو ليس عنوان الاستدعاء الخاص بفيدلن (فريق DevOps)",
          "owner_not_decided": "لم تُختر سياسة مالك العملاء المحتملين (يقرّرها صاحب الحساب ويضبطها فريق DevOps على الخادم)",
          "owner_id_invalid": "مُعرّف مستخدم مالك العملاء المحتملين في Zoho على الخادم مفقود أو غير صالح (فريق DevOps)",
          "owner_policy_conflict": "يُسند العملاء المحتملون الجدد إلى المستخدم الذي أجرى الربط، لكن مُعرّف مالك مضبوط أيضاً على الخادم: يجب إزالة أحدهما (فريق DevOps)",
          "owner_unverified": "لم يُتحقق من أن مالك العملاء المحتملين المُعدّ مستخدم نشط في Zoho، لذلك لا يُكتب شيء: تحقّق من المستخدم في Zoho ثم أعد الربط",
          "environment_guard": "محظور: لا يكتب نظام اختبار في مؤسسة Zoho الإنتاجية، ولا يكتب نظام الإنتاج في مؤسسة تجريبية (فريق DevOps)",
          "not_connected": "Zoho CRM غير مرتبط: اربطه من هذه الصفحة",
          "connection_mismatch": "الربط يخص مؤسسة أو بيئة أو مركز بيانات غير المضبوط على الخادم: أعد الربط أو صحّح الإعدادات (فريق DevOps)",
          "authorisation_revoked": "رفض Zoho التفويض المحفوظ (أُلغي أو انتهت صلاحيته): أعد الربط من هذه الصفحة",
          "unknown": "مشكلة لا تعرفها هذه الواجهة"
        },
        "refusal": {
          "state_invalid": "انتهت صلاحية طلب الربط أو استُخدم من قبل أو لم يُتعرّف عليه: ابدأ من جديد",
          "session_mismatch": "المشغّل المسجّل دخوله هنا غير الذي بدأ الربط: ابدأ من جديد من جلستك",
          "operator_not_permitted": "المشغّل الذي بدأ الربط لم يعد نشطاً أو لم يعد مخوّلاً بإدارة التكاملات",
          "consent_denied": "لم يُمنح الإذن في Zoho",
          "accounts_server_mismatch": "جاء ردّ Zoho من خادم حسابات غير المُعدّ (فريق DevOps)",
          "not_configured": "الخادم غير مُعدّ لربط Zoho: راجع المشكلات في هذه الصفحة (فريق DevOps)",
          "code_missing": "لم يُعِد Zoho رمز التفويض: ابدأ من جديد",
          "code_exchange_failed": "لم يُبادل Zoho رمز التفويض: ابدأ من جديد، وإن تكرر ذلك فراجع إعدادات العميل (فريق DevOps)",
          "api_domain_mismatch": "فوّض Zoho عنوان واجهة برمجة غير المُعدّ، ولم يُحفظ شيء (فريق DevOps)",
          "org_check_failed": "تعذّر على فيدلن قراءة مؤسسة Zoho للتحقق منها، ولم يُحفظ شيء: حاول مرة أخرى",
          "org_mismatch": "الحساب المُفوَّض في Zoho ليس المؤسسة المُعدّة، ولم يُحفظ شيء: سجّل الدخول في Zoho بمؤسسة صاحب الحساب"
        }
      }
    }
  }
}
